import { render, staticRenderFns } from "./table.all-gigs.vue?vue&type=template&id=36e37caf&scoped=true&"
import script from "./table.all-gigs.vue?vue&type=script&lang=js&"
export * from "./table.all-gigs.vue?vue&type=script&lang=js&"
import style0 from "./table.all-gigs.vue?vue&type=style&index=0&id=36e37caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e37caf",
  null
  
)

export default component.exports